module.exports = __webpack_public_path__ + "img/_15.8e90960e.png";